/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetSpaceAvailabilityPathParameters } from 'api/actions/get-space-availability/get-space-availability-path-parameters';
import { GetSpaceAvailabilityResponse } from 'api/actions/get-space-availability/get-space-availability-response';

type GetSpaceAvailabilityQueryParameters = Record<string, any>;

/**
 * The path of the GetSpaceAvailability action.
 */
export const getSpaceAvailabilityActionPath = new SweetPath<keyof GetSpaceAvailabilityPathParameters>(
  '/reservations/spaces/{id}/availability',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetSpaceAvailability actions.
 */
export default function createGetSpaceAvailabilityAction(axios: AxiosInstance) {
  return function getSpaceAvailabilityAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetSpaceAvailabilityPathParameters;
    query?: GetSpaceAvailabilityQueryParameters;
  }) {
    const path = getSpaceAvailabilityActionPath.insert(parameters);

    return axios.get<GetSpaceAvailabilityResponse, GetSpaceAvailabilityResponse>(path, { params: query, headers });
  };
}
